export const handleNavDisplay = (
  currentPageSize,
  itemLength,
  prevButton,
  nextButton,
  nav
) => {
  if (currentPageSize >= itemLength) {
    prevButton.style.display = "none";
    nextButton.style.display = "none";
    nav.style.display = "none";
  } else {
    prevButton.style.display = "block";
    nextButton.style.display = "block";
    nav.style.display = "inherit";
  }
};
